//Don't know why but I cant rename this file to Contract.Globals.Actions.js
// import axiosClient from 'axios';
import axios from '../../http.service';
import {
	GET_QUALIFICATION_YEARS,
	UPDATE_ACTIVE_QUALIFICATION_YEAR,
	GET_DISAPLAY_STATUS,
	CONTRACT_GLOBALS_ERROR,
	GET_APPOINTMENT_TYPES,
	UPDATED_GROUPING_AND_TYPES,
	AUTH_ERROR,
	ADD_TOAST_MESSAGE,
	UPDATE_REFINER_SELECTORS
} from '../Enums/Contracts.Globals.Enums';
import { isErrorCode, hasValue } from '../../utils';

// const axios = axiosClient.create();
// axios.defaults.headers.common['Authorization'] = globals.accessToken;

const isAuthError = error => {
	return isErrorCode(error, 401) || isErrorCode(error, 403);
};

export const getCurrentQualificationYears = () => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/years`);
			if (resp.status === 200) {
				dispatch({ type: GET_QUALIFICATION_YEARS, payload: resp.data });
			} else if (resp.status === 401 || resp.status === 403) {
				dispatch({ type: AUTH_ERROR });
			} else {
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: {
						data: resp.data,
						errorMessage: `Error when retrieving Qualification Years.`
					}
				});
			}
		} catch (error) {
			if (isAuthError(error)) {
				dispatch({ type: AUTH_ERROR });
			} else {
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: {
						errorMessage: error.message
					}
				});
			}
		}
	};
};

export const updateSelectedQualYear = value => {
	return dispatch => dispatch({ type: UPDATE_ACTIVE_QUALIFICATION_YEAR, payload: value });
};

export const updateRefinerSelectors = value => {
	return dispatch => dispatch({ type: UPDATE_REFINER_SELECTORS, payload: value });
};

export const getAppointmentTypes = year => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/types${year ? `?qualificationYear=${year}` : ''}`);
			if (resp.status === 200) {
				dispatch({ type: GET_APPOINTMENT_TYPES, payload: resp.data });
			} else if (resp.status === 401 || resp.status === 403) {
				dispatch({ type: AUTH_ERROR });
			} else {
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: {
						data: resp.data.data,
						errors: [...resp.data.errors, `Error retreiving Appointment Types`]
					}
				});
			}
		} catch (error) {
			if (isAuthError(error)) {
				dispatch({ type: AUTH_ERROR });
			} else {
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: { data: [], errors: [error] }
				});
			}
		}
	};
};

export const updatedSelectedAppointmentTypes = (groupingData = {}) => {
	const { key: grouping = null, value: types = [] } = groupingData;
	return dispatch => {
		try {
			if (hasValue(grouping) && Array.isArray(types) && types.length > 0)
				dispatch({
					type: UPDATED_GROUPING_AND_TYPES,
					payload: {
						data: { grouping, types },
						errors: []
					}
				});
			else
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: {
						data: groupingData,
						errors: ['Cannot update Grouping as no value was provided']
					}
				});
		} catch (error) {
			dispatch({
				type: CONTRACT_GLOBALS_ERROR,
				payload: { data: [], errors: error.message }
			});
		}
	};
};

export const getDisplayStatus = () => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/displaystatus`);
			if (resp.status === 200) dispatch({ type: GET_DISAPLAY_STATUS, payload: resp.data });
			else
				dispatch({
					type: CONTRACT_GLOBALS_ERROR,
					payload: {
						data: resp.data,
						errorMessage: `Error when retrieving display status`
					}
				});
		} catch (err) {
			dispatch({
				type: CONTRACT_GLOBALS_ERROR,
				payload: { errorMessage: err.message }
			});
		}
	};
};

export const addToastMessage = payload => {
	return async dispatch => {
		dispatch({
			type: ADD_TOAST_MESSAGE,
			payload
		});
	}
}
